import { getGameConfig } from '../../../shared/gameConfig';
import { IClassicGameConfig } from '../../../shared/gameConfig/wowclassic/types';

export const gameConfig = getGameConfig<IClassicGameConfig>();
